import React from "react";

const Intro = () => {
    return (
        <div className="mr-40 ml-40 p-10 bg-[#172554] rounded-lg shadow-lg">
            <p className="mb-3 text-white dark:text-white first-line:uppercase first-line:tracking-widest first-letter:text-7xl first-letter:font-bold first-letter:text-white-900 dark:first-letter:text-black-100 first-letter:mr-3 first-letter:float-left">
                Welcome to RTLSA, the cutting-edge web application that lets you
                stay connected like never before. Our real-time location sharing
                feature is designed to bring people closer together, enhance
                safety, and streamline logistics. Whether you're reconnecting
                with friends and family, coordinating with colleagues, or
                ensuring the safety of your loved ones, our location sharing
                feature makes it simple, secure, and efficient.
            </p>
        </div>
    );
};

export default Intro;
